import compose from "recompose/compose"
import { graphqlDynamic } from "../graphqlDynamic"
import { withKpiScope } from "@/helpers/hoc/withKpiScope"
import { dateISO } from "@/helpers/dates"
import relevantBenchmarkQuery from "./BenchmarkQuery.gql"
import withBenchmarkSettingsContext from "@/helpers/hoc/withBenchmarkSettingsContext"
import mapBenchmarkSettings from "./mapBenchmarkSettings"

const query = (props) => {
  const { companyIds, id: field, scope, contextProps } = props
  const benchmarkSettings = contextProps ? contextProps.benchmarkSettings : null
  const settings = mapBenchmarkSettings(benchmarkSettings)

  return relevantBenchmarkQuery({ field, companyIds, scope, settings })
}

const queryOptions = ({ companyIds, from, id, to, contextProps }) => {
  const benchmarkSettings = contextProps ? contextProps.benchmarkSettings : null
  companyIds = !!companyIds ? companyIds : []
  const settings = mapBenchmarkSettings(benchmarkSettings)
  const variables = {
    from: from && dateISO(from),
    to: to && dateISO(to),
    companyIds,
    settings,
  }

  return { notifyOnNetworkStatusChange: true, variables }
}

const queryProps = ({ data, ownProps: { id, scope } }) => ({
  error: data.error,
  loading: data.loading,
  benchmarkValue: data[scope]?.[`kpis`][id].benchmark,
})

const queryConfig = { options: queryOptions, props: queryProps }

export default compose(
  withKpiScope,
  withBenchmarkSettingsContext,
  graphqlDynamic(query, queryConfig),
)
